package org.example.zone360.models

import kotlinx.serialization.Serializable

@Serializable
data class CreateKeywordsResponse(
    val data: List<CreateKeywordsData>,
)

@Serializable
data class CreateKeywordsData(
    val createdAt: String,
    val domainType: String,
    val id: String,
    val isDefault: Boolean,
    val keywordCategory: String,
    val language: String,
    val organization: String,
    val text: String,
    val type: String,
)


@Serializable
data class KeywordsPayload(
    val keywordsList: List<String>,
    val keywordCategory: String,
    val organization: String,
    val language: String
)

@Serializable
data class CustomKeywordsResponse(
    val data: List<CustomKeywordsData>,
)

@Serializable
data class CustomKeywordsData(
    val id: String? = null,
    val isDefault: Boolean,
    val keywordCategory: String,
    val language: String,
    val text: String,
)

@Serializable
data class CustomKeywordPayload(
    val organization: String,
    val seasonID: String,
)
